"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _styledComponents = require("styled-components");
var _A = _interopRequireDefault(require("./A"));
var _helpers = require("./helpers");
var _StyledButton = _interopRequireDefault(require("./StyledButton"));
var _types = require("./types");
var _jsxFileName = "/codebuild/output/src3108803385/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Button/lib/Button.js",
  _this = void 0;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_g9uder0ek() {
  var path = "/codebuild/output/src3108803385/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Button/lib/Button.js";
  var hash = "f81ae7bf5b8c7c1e60d0239de2c1ae9d0902a958";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3108803385/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Button/lib/Button.js",
    statementMap: {
      "0": {
        start: {
          line: 17,
          column: 27
        },
        end: {
          line: 17,
          column: 76
        }
      },
      "1": {
        start: {
          line: 20,
          column: 15
        },
        end: {
          line: 60,
          column: 1
        }
      },
      "2": {
        start: {
          line: 21,
          column: 79
        },
        end: {
          line: 21,
          column: 84
        }
      },
      "3": {
        start: {
          line: 22,
          column: 18
        },
        end: {
          line: 22,
          column: 28
        }
      },
      "4": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 27,
          column: 5
        }
      },
      "5": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 26,
          column: 5
        }
      },
      "6": {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 25,
          column: 38
        }
      },
      "7": {
        start: {
          line: 28,
          column: 19
        },
        end: {
          line: 28,
          column: 34
        }
      },
      "8": {
        start: {
          line: 29,
          column: 24
        },
        end: {
          line: 29,
          column: 57
        }
      },
      "9": {
        start: {
          line: 30,
          column: 2
        },
        end: {
          line: 32,
          column: 5
        }
      },
      "10": {
        start: {
          line: 33,
          column: 2
        },
        end: {
          line: 46,
          column: 3
        }
      },
      "11": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 45,
          column: 6
        }
      },
      "12": {
        start: {
          line: 47,
          column: 2
        },
        end: {
          line: 59,
          column: 4
        }
      },
      "13": {
        start: {
          line: 62,
          column: 0
        },
        end: {
          line: 100,
          column: 2
        }
      },
      "14": {
        start: {
          line: 102,
          column: 0
        },
        end: {
          line: 121,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 20,
            column: 15
          },
          end: {
            line: 20,
            column: 16
          }
        },
        loc: {
          start: {
            line: 20,
            column: 24
          },
          end: {
            line: 60,
            column: 1
          }
        },
        line: 20
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 23,
            column: 29
          },
          end: {
            line: 23,
            column: 30
          }
        },
        loc: {
          start: {
            line: 23,
            column: 36
          },
          end: {
            line: 27,
            column: 3
          }
        },
        line: 23
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 26,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 26,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 24
      },
      "1": {
        loc: {
          start: {
            line: 29,
            column: 24
          },
          end: {
            line: 29,
            column: 57
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 29,
            column: 31
          },
          end: {
            line: 29,
            column: 33
          }
        }, {
          start: {
            line: 29,
            column: 36
          },
          end: {
            line: 29,
            column: 57
          }
        }],
        line: 29
      },
      "2": {
        loc: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 46,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 46,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 33
      },
      "3": {
        loc: {
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 33,
            column: 26
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 33,
            column: 17
          }
        }, {
          start: {
            line: 33,
            column: 21
          },
          end: {
            line: 33,
            column: 26
          }
        }],
        line: 33
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f81ae7bf5b8c7c1e60d0239de2c1ae9d0902a958"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_g9uder0ek = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_g9uder0ek();
var availableModifiers = (cov_g9uder0ek().s[0]++, ['small', 'large', 'neutral', 'flat', 'disabled']);

/** Common component to display a clickable action */
cov_g9uder0ek().s[1]++;
var Button = function Button(props) {
  cov_g9uder0ek().f[0]++;
  var _ref = (cov_g9uder0ek().s[2]++, props),
    href = _ref.href,
    alt = _ref.alt,
    customRef = _ref.customRef,
    handleRoute = _ref.handleRoute,
    children = _ref.children,
    ariaFields = _ref.ariaFields,
    variant = _ref.variant;
  var className = (cov_g9uder0ek().s[3]++, 'g-Button');
  cov_g9uder0ek().s[4]++;
  availableModifiers.forEach(function (mod) {
    cov_g9uder0ek().f[1]++;
    cov_g9uder0ek().s[5]++;
    if (props[mod]) {
      cov_g9uder0ek().b[0][0]++;
      cov_g9uder0ek().s[6]++;
      className += " g-Button-".concat(mod);
    } else {
      cov_g9uder0ek().b[0][1]++;
    }
  });
  var newTheme = (cov_g9uder0ek().s[7]++, (0, _helpers.getTheme)(props));
  var ariaAttribute = (cov_g9uder0ek().s[8]++, !alt ? (cov_g9uder0ek().b[1][0]++, {}) : (cov_g9uder0ek().b[1][1]++, {
    'aria-label': alt
  }));
  cov_g9uder0ek().s[9]++;
  className = (0, _utils.classNames)("".concat(className), (0, _defineProperty2.default)({}, "g-Button-".concat(variant), variant));
  cov_g9uder0ek().s[10]++;
  if ((cov_g9uder0ek().b[3][0]++, handleRoute) || (cov_g9uder0ek().b[3][1]++, !href)) {
    cov_g9uder0ek().b[2][0]++;
    cov_g9uder0ek().s[11]++;
    return /*#__PURE__*/_react.default.createElement(_StyledButton.default, (0, _extends2.default)({
      innerRef: customRef,
      onClick: handleRoute,
      clsName: className
    }, props, ariaAttribute, ariaFields, {
      theme: newTheme,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 35,
        columnNumber: 7
      }
    }), _react.Children.toArray(children));
  } else {
    cov_g9uder0ek().b[2][1]++;
  }
  cov_g9uder0ek().s[12]++;
  return /*#__PURE__*/_react.default.createElement(_A.default, (0, _extends2.default)({}, props, {
    theme: newTheme,
    innerRef: customRef,
    href: href,
    onClick: props.onClick,
    clsName: className
  }, ariaAttribute, ariaFields, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 5
    }
  }), _react.Children.toArray(children));
};
cov_g9uder0ek().s[13]++;
Button.propTypes = {
  /** May be use to access a route if the system use the react router */
  handleRoute: _propTypes.default.func,
  /** redirect to a simple page */
  href: _propTypes.default.string,
  /** action linked to the button */
  onClick: _propTypes.default.func,
  /** The text or html node displayed on the button */
  children: _propTypes.default.node.isRequired,
  /** give the ability to define a fixed width for buttons and then set overflow to hidden */
  width: _propTypes.default.string,
  /** Do not modify the text size but put small padding */
  small: _propTypes.default.bool,
  /** Set neutral grey color on the button */
  neutral: _propTypes.default.bool,
  /** Make the font-size bigger and adapt padding accordingly */
  large: _propTypes.default.bool,
  /** Use grey color to show that it is disabled and it is not possible to click it */
  disabled: _propTypes.default.bool,
  /** Do not show the background and use background color for text */
  flat: _propTypes.default.bool,
  /** Define how many line a button must contain */
  lines: _propTypes.default.number,
  /** Draw a button with background transparent and bordered */
  outline: _propTypes.default.bool,
  /* Alt content of icon - Use for accessibility */
  alt: _propTypes.default.string,
  /* Custom element reference */
  // eslint-disable-next-line react/forbid-prop-types
  customRef: _propTypes.default.any,
  theme: _propTypes.default.shape({}),
  ariaFields: _propTypes.default.objectOf(_propTypes.default.string),
  /* theme queries */
  themeQueries: _utils.WithThemeQueriesType,
  /* theme context */
  themeContext: _themeProvider.ThemeContextType,
  /* variant */
  variant: _types.ButtonVariantType
};
cov_g9uder0ek().s[14]++;
Button.defaultProps = {
  handleRoute: undefined,
  href: undefined,
  onClick: undefined,
  width: undefined,
  small: false,
  neutral: false,
  large: false,
  disabled: false,
  flat: false,
  lines: 1,
  outline: false,
  alt: undefined,
  customRef: null,
  ariaFields: {},
  theme: {},
  themeQueries: {},
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  variant: _types.ButtonVariant.primary
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)((0, _styledComponents.withTheme)(Button)));